import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { timeout } from 'rxjs/operators';
import { environment } from "./../../../environments/environment";
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "./encryption.service";
export class ApiService {
    constructor(http, encryptionProviderService) {
        this.http = http;
        this.encryptionProviderService = encryptionProviderService;
    }
    getData(endPoint) {
        return Observable.create((observer) => {
            this.http
                .get(endPoint)
                .pipe(timeout(60000))
                .subscribe((response) => {
                if (response['eData']) {
                    response = JSON.parse(this.encryptionProviderService.decryptData(response['eData']));
                }
                if (response.status === 0) {
                    observer.next(response);
                }
                else {
                    observer.error(response);
                }
            }, (error) => {
                observer.error(error);
            }, () => observer.complete());
        });
    }
    postData(endPoint, data) {
        return Observable.create((observer) => {
            if (environment.isEncryptionEnabled) {
                data = !data ? {} : data;
                data.guid = this.generateGuid(endPoint);
                data.timeStamp = Date.now();
                data = {
                    eData: this.encryptionProviderService.encryptData(JSON.stringify(data)),
                };
            }
            this.http
                .post(endPoint, data)
                .pipe(timeout(60000))
                .subscribe((response) => {
                if (response['eData']) {
                    response = JSON.parse(this.encryptionProviderService.decryptData(response['eData']));
                }
                if (response.status === 0) {
                    observer.next(response);
                }
                else {
                    observer.error(response);
                }
            }, (error) => {
                observer.error(error);
            }, () => observer.complete());
        });
    }
    generateGuid(url) {
        let result = '';
        const length = 32;
        const chars = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ';
        for (let i = length; i > 0; --i) {
            result += chars[Math.round(Math.random() * (chars.length - 1))];
        }
        this.encryptionProviderService.setGuid({
            key: url,
            value: result,
        });
        return result;
    }
}
ApiService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function ApiService_Factory() { return new ApiService(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(i2.EncryptionProviderService)); }, token: ApiService, providedIn: "root" });
